export const calculateTbw = (icw?: number, ecw?: number) => {
  if (!icw || !ecw) {
    return null;
  }

  return +(icw + ecw).toFixed(1);
};
